import { useEffect, useState } from 'react';
import EditorControls from './EditorControls';
import './index.scss';
import { IconChange } from '../../icons/svgs';

function Editor({ slides, selectedSlide, selectedSlideIndex, setActionUpdateTemplate, reRender, showModalCrop }) {
    // console.log('slide ke new index ',slides[selectedSlideIndex]);
    // console.log('selected slide ', selectedSlide);
    const [saveDisabled, setSaveDisabled] = useState('');

    const showModalNewSlide = () => {
        setActionUpdateTemplate(true)
        window.jQuery('#tbcourse-modal-new-slide').modal('show');
    }

    useEffect(() => {
        if (selectedSlide) {
            setSaveDisabled(selectedSlide.saveDisabled)
        }
    });

    return (
        <div className="tbcourse-editor">
            <div className="tbcourse-header tbcourse-editor-header">
                <div className="tbcourse-header-title">
                    {selectedSlide?.template?.name() ?? "-"}
                </div>
                <div className="tbcourse-header-action">
                    {(selectedSlide?.canDelete() &&
                        <button type='button' className='btn font-size-12' onClick={showModalNewSlide} disabled={saveDisabled}>
                            Change < IconChange />
                        </button>
                    )}
                </div>
            </div>
            <div className="tbcourse-body tbcourse-editor-body">
                <EditorControls slides={slides} selectedSlide={selectedSlide} selectedSlideIndex={selectedSlideIndex} structures={selectedSlide?.template?.structures() ?? {}} reRender={reRender} showModalCrop={showModalCrop} />
            </div>
        </div >
    );
}

export default Editor;
